import React from "react";
import classNames from "classnames";
import styles from "./TableCounter.module.scss"
import _ from "lodash";
import { Button } from "./../../";

export default ({ totalCount, filteredCount, singularLabel, pluralLabel, selectedCount, className, style, onResetFilter, activeFiltersCount }) => {
    return <div className={classNames(styles['base'], className)} style={style}>
        <span>{totalCount === 1 ? singularLabel : pluralLabel}</span>
        <span>&nbsp;({(_.isNumber(filteredCount) && filteredCount < totalCount) ? <span>{filteredCount} / </span> : ""}{_.isNumber(totalCount) ? totalCount : "-"})</span>
        {!!activeFiltersCount && activeFiltersCount > 0 && <span>&nbsp;<div className={styles.divider}/> Filtered by {activeFiltersCount} parameter{activeFiltersCount > 1 ? "s" : ""}</span>}
        {!!selectedCount && selectedCount > 0 && <span>&nbsp;<div className={styles.divider}/> {selectedCount} selected</span>}
        {onResetFilter && activeFiltersCount > 0 && <Button variant="text" onClick={onResetFilter} className={styles.reset}>Reset filter</Button>}
    </div>
};